function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-7-9h24v24H-7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#141823",
  d: "M3.84 5.376c.64.897 1.676.901 2.32 0l2.68-3.752C9.48.727 9.113 0 8 0H2C.895 0 .516.723 1.16 1.624l2.68 3.752z"
}));

function SvgArrowDropDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7
  }, props), _ref);
}

export default SvgArrowDropDown;